module.exports = {
	"desktop": [
		{
			"name": "Getting Pregnant",
			"url": "/category/getting-pregnant",
			"class": "left menu_one main_list",
			"subclass": "sublist menu_one_sublist",
			"subsubclass": "submenulist menu_one_sublist_submenus",
			"submenu": [
				{
					"name": "Planning and Preparing",
					"url": "/subcat/getting-pregnant/planning-preparing"
				},
				{
					"name": "Trying to Conceive",
					"url": "/subcat/getting-pregnant/trying-to-conceive"
				},
				{
					"name": "Fertility",
					"url": "/subcat/getting-pregnant/fertility"
				},
				{
					"name": "Infertility",
					"url": "/subcat/getting-pregnant/infertility"
				}
			]
		},
		{
			"name": "Pregnancy",
			"url": "/category/pregnancy",
			"class": "left menu_two main_list",
			"subclass": "sublist menu_two_sublist",
			"subsubclass": "submenulist menu_two_sublist_submenus",
			"submenu": [
				{
					"name": "Pregnancy Week by Week",
					"url": "/subcat/pregnancy/week-by-week"
				},
				{
					"name": "Prenatal Care",
					"url": "/subcat/pregnancy/prenatal-care"
				},
				{
					"name": "Signs & Symptoms",
					"url": "/subcat/pregnancy/signs-and-symptoms"
				},
				{
					"name": "Labour & Delivery",
					"url": "/subcat/pregnancy/labour-and-delivery"
				},
				{
					"name": "Complications",
					"url": "/subcat/pregnancy/complications"
				},
				{
					"name": "Diet & Nutrition",
					"url": "/subcat/pregnancy/diet-and-nutrition"
				},
				{
					"name": "Postnatal Care",
					"url": "/subcat/pregnancy/postnatal-care"
				}
			]
		},
		{
			"name": "Baby",
			"url": "/category/baby",
			"class": "left menu_three main_list",
			"subclass": "sublist menu_three_sublist",
			"subsubclass": "submenulist menu_three_sublist_submenus",
			"submenu": [
				{
					"name": "Development Month by Month",
					"url": "/subcat/baby/development-month-by-month"
				},
				{
					"name": "Baby Care",
					"url": "/subcat/baby/care"
				},
				{
					"name": "Health",
					"url": "/subcat/baby/health"
				},
				{
					"name": "Vaccination Schedule",
					"url": "/vaccine-immunization-schedule"
				},
				{
					"name": "Safety",
					"url": "/subcat/baby/safety"
				},
				{
					"name": "Breastfeeding",
					"url": "/subcat/baby/breastfeeding"
				},
				{
					"name": "Food & Nutrition",
					"url": "/subcat/baby/food-and-nutrition"
				},
				{
					"name": "Feeding",
					"url": "/subcat/baby/feeding"
				},
				{
					"name": "Baby Sleep Basics",
					"url": "/subcat/baby/baby-sleep-basics"
				}
			]
		},
		{
			"name": "Toddler",
			"url": "/category/toddler",
			"class": "left menu_four main_list",
			"subclass": "sublist menu_four_sublist",
			"subsubclass": "submenulist menu_four_sublist_submenus",
			"submenu": [
				{
					"name": "Care",
					"url": "/subcat/toddler/care"
				},
				{
					"name": "Health",
					"url": "/subcat/toddler/health"
				},
				{
					"name": "Food & Nutrition",
					"url": "/subcat/toddler/food-and-nutrition"
				},
				{
					"name": "Play & Activities",
					"url": "/subcat/toddler/play-and-activities"
				}
			]
		},
		{
			"name": "Preschooler",
			"url": "/category/preschooler",
			"class": "left menu_five main_list",
			"subclass": "sublist menu_five_sublist",
			"subsubclass": "submenulist menu_five_sublist_submenus",
			"submenu": [
				{
					"name": "Food & Nutrition",
					"url": "/subcat/preschooler/food-and-nutrition"
				},
				{
					"name": "Behavior & Discipline",
					"url": "/subcat/preschooler/behavior-and-discipline"
				},
				{
					"name": "Play & Activities",
					"url": "/subcat/preschooler/play-and-activities"
				},
				{
					"name": "Care",
					"url": "/subcat/preschooler/care"
				},
				{
					"name": "Health",
					"url": "/subcat/preschooler/health"
				},
				{
					"name": "Safety",
					"url": "/subcat/preschooler/safety"
				}
			]
		},
		{
			"name": "Big Kid",
			"url": "/category/toddler",
			"class": "left menu_six main_list",
			"subclass": "sublist menu_six_sublist",
			"subsubclass": "submenulist menu_six_sublist_submenus",
			"submenu": [
				{
					"name": "Development",
					"url": "/subcat/big-kid/development"
				},
				{
					"name": "Food & Nutrition",
					"url": "/subcat/big-kid/food-and-nutrition"
				},
				{
					"name": "Behavior & Discipline",
					"url": "/subcat/big-kid/behavior-and-discipline"
				},
				{
					"name": "Play & Activities",
					"url": "/subcat/big-kid/play-and-activities"
				},
				{
					"name": "Care",
					"url": "/subcat/big-kid/care"
				},
				{
					"name": "Health",
					"url": "/subcat/big-kid/health"
				},
				{
					"name": "Safety",
					"url": "/subcat/big-kid/safety"
				}
			]
		},
		{
			"name": "Tools",
			"url": "/tools",
			"class": "left menu_seven main_list",
			"subclass": "sublist menu_seven_sublist",
			"subsubclass": "submenulist menu_seven_sublist_submenus",
			"submenu": [
				{
					"name": "Q&A",
					"url": "/qna/questions-answers"
				},
				{
					"name": "Contest & Winners",
					"url": "/baby-photo-contest"
				},
				{
					"name": "Videos",
					"url": "/videos"
				},
				{
					"name": "Parenting Tools",
					"url": "/tools",
					"subsubmenu": [
						{
							"name": "Child Vaccination & Growth Tracker",
							"url": "/tools/child-vaccination-growth-tracker"
						},
						{
							"name": "Breastfeeding Tracker",
							"url": "/tools/breastfeeding-tracker"
						},
						{
							"name": "Memories",
							"url": "/memories"
						},
						{
							"name": "Milestone",
							"url": "/memories/milestones"
						},
						{
							"name": "Baby Teething",
							"url": "/tools/baby-teething"
						},
						{
							"name": "Face A Day",
							"url": "/tools/capture-baby-moments"
						}
					]
				},
				{
					"name": "Pregnancy Tools",
					"url": "/tools",
					"subsubmenu": [
						{
							"name": "Baby Kick Counter",
							"url": "/tools/fetal-movement-tracker"
						},
						{
							"name": "Due Date Calculator",
							"url": "/tools/pregnancy-due-date-calculator"
						},
						{
							"name": "Baby Size Comparison",
							"url": "/tools/baby-size-comparison"
						},
						{
							"name": "My Bumpie",
							"url": "/tools/my-baby-bump"
						},
						{
							"name": "Week by Week Fetal Development",
							"url": "/tools/pregnancy-week-by-week-tracker"
						},
						{
							"name": "Fetal Development Video",
							"url": "/tools/fetal-development-video"
						}
					]
				},
				{
					"name": "Other Tools",
					"url": "/tools",
					"subsubmenu": [
						{
							"name": "Period & Ovulation Calculator",
							"url": "/tools/period-ovulation-calculator"
						}
					]
				}
			]
		},
		{
			"name": "Memories",
			"url": "/memories",
			"class": "left menu_eight main_list",
			"subclass": "sublist menu_eight_sublist",
			"subsubclass": "submenulist menu_eight_sublist_submenus"
		},
		{
			"name": "Baby Names",
			"url": "/baby-names",
			"class": "left menu_nine main_list",
			"subclass": "sublist menu_nine_sublist",
			"subsubclass": "submenulist menu_nine_sublist_submenus"
		}
	],
	"mobile": [
		{
			"name": "Home",
			"url": "/",
			"image": "https://cdn.fcglcdn.com/brainbees/apps/image/parenting_menu_icons_home_menu.svg"
		},
		{
			"name": "Read",
			"url": "",
			"image": "https://cdn.fcglcdn.com/brainbees/apps/image/parenting_menu_icons_read_menu.svg",
			"subid": "Readmenulist",
			"arrowid": "read_id",
			"submenu": [
				{
					"name": "Getting Pregnant",
					"url": "/category/getting-pregnant/"
				},
				{
					"name": "Pregnancy",
					"url": "/category/pregnancy/"
				},
				{
					"name": "Baby",
					"url": "/category/baby/"
				},
				{
					"name": "Preschooler",
					"url": "/category/preschooler/"
				},
				{
					"name": "Big Kid",
					"url": "/category/big-kid/"
				},
				{
					"name": "Magazine",
					"url": "/category/magazine/"
				},
				{
					"name": "Toddler",
					"url": "/category/toddler/"
				}
			]
		},
		{
			"name": "Q&A",
			"url": "/qna/questions-answers",
			"image": "https://cdn.fcglcdn.com/brainbees/apps/image/parenting_menu_icons_qna_menu.svg"
		},
		{
			"name": "Expert Panel",
			"url": "/experts",
			"image": "https://cdn.fcglcdn.com/brainbees/apps/image/parenting_menu_icons_expert_icon.svg"
		},
		{
			"name": "Contest & Winners",
			"url": "/baby-photo-contest",
			"image": "https://cdn.fcglcdn.com/brainbees/apps/image/parenting_menu_icons_memory_contest_menu.svg"
		},
		{
			"name": "Videos",
			"url": "/videos",
			"image": "https://cdn.fcglcdn.com/brainbees/apps/image/parenting_menu_icons_videos_menu.svg"
		},
		{
			"name": "Memories",
			"url": "/memories",
			"image": "https://cdn.fcglcdn.com/brainbees/apps/image/parenting_menu_icons_memory_menu.svg"
		},
		{
			"name": "Parenting Tools",
			"url": "",
			"image": "https://cdn.fcglcdn.com/brainbees/apps/image/parenting_menu_icons_parenting_tool_menu.svg",
			"subid": "parentingtoollist",
			"arrowid": "parenting_id",
			"submenu": [
				{
					"name": "Vaccination Tracker",
					"url": "/tools/child-vaccination-growth-tracker"
				},
				{
					"name": "Growth Tracker",
					"url": "/tools/child-vaccination-growth-tracker"
				},
				{
					"name": "Diet Plan (6 Months+)",
					"url": "/tools/baby-kids-diet-plan"
				},
				{
					"name": "Baby Growth & Development",
					"url": "/tools/baby-growth-and-development"
				},
				{
					"name": "Breastfeeding",
					"url": "/tools/breastfeeding-tracker"
				},
				{
					"name": "Memories",
					"url": "/memories"
				},
				{
					"name": "Milestone",
					"url": "/memories/milestones"
				},
				{
					"name": "Face A Day",
					"url": "/tools/capture-baby-moments"
				},
				{
					"name": "Baby Teething",
					"url": "/tools/baby-teething"
				}
			]
		},
		{
			"name": "Pregnancy Tools",
			"url": "",
			"image": "https://cdn.fcglcdn.com/brainbees/apps/image/parenting_menu_icons_my_bumpie_menu.svg",
			"subid": "pregnancytoollist",
			"arrowid": "pragnency_id",
			"submenu": [
				{
					"name": "Baby Kick Counter",
					"url": "/tools/fetal-movement-tracker"
				},
				{
					"name": "Baby Names",
					"url": "/baby-names"
				},
				{
					"name": "Due Date Calculator",
					"url": "/tools/pregnancy-due-date-calculator"
				},
				{
					"name": "Diet Plan (Expecting Mom’s)",
					"url": "/tools/pregnancy-diet-plan"
				},
				{
					"name": "Pregnancy Inspection Schedule",
					"url": "/tools/pregnancy-checkup-schedule"
				},
				{
					"name": "My Bumpie",
					"url": "/tools/my-baby-bump"
				},
				{
					"name": "Baby Size Comparison",
					"url": "/tools/baby-size-comparison"
				},
				{
					"name": "Fetal Development Video",
					"url": "/tools/fetal-development-video"
				},
				{
					"name": "Week by Week Fetal Development",
					"url": "/tools/pregnancy-week-by-week-tracker"
				}
			]
		},
		{
			"name": "Other Tools",
			"url": "",
			"image": "https://cdn.fcglcdn.com/brainbees/apps/image/parenting_menu_icons_tool_icon_menu.svg",
			"subid": "othertoollist",
			"arrowid": "other_tools_id",
			"submenu": [
				{
					"name": "Period & Ovulation Calculator",
					"url": "/tools/period-ovulation-calculator"
				}
			]
		}
	],
	"dropdown": [
		{
			"name": "My Profile",
			"url": "/my-account"
		},
		{
			"name": "My Memories",
			"url": "/my-account/mymemories"
		},
		{
			"name": "My Milestones",
			"url": "/my-account/my-milestones"
		},
		{
			"name": "My Bumpie",
			"url": "/my-account/mybumpie"
		},
		{
			"name": "My Favourite Names",
			"url": "/my-account/favorite-baby-names"
		}
	]
};


//////////////////
// WEBPACK FOOTER
// ./src/shared/header/Menu.json
// module id = 307
// module chunks = 0